import React from "react";
import styles from "./button.module.scss";
// import dynamic from "next/dynamic";
interface ButtonProps {
    children?: any;
    disableBtn?: boolean;
    className?: any;
    template?: "gray" | "blue" | "orange" | "orange_outline";
    label: string;
    icon?: string;
    size?: "small" | "large";
    onClick?: () => void;
}
// let DynamicComponent : any;

// const changeIcon = (icon) => {
// DynamicComponent = dynamic(() =>
//     import("react-icons/md").then((mod) => mod[icon])
// );
// };

export const Button: React.FC<ButtonProps> = ({
    disableBtn = false,
    className,
    onClick,
    label,
    template,
    icon,
    size,
}) => {
    const Icon = React.lazy((): any =>
        import("react-icons/md").then((module) => ({ default: module[icon] }))
    );
    return (
        <button
            disabled={disableBtn}
            type="submit"
            className={[
                className,
                styles.btn,
                styles[`btn_${template}`],
                styles[`btn_${size}`],
            ].join(" ")}
            onClick={onClick}
        >
            {icon && (
                <React.Suspense fallback={null}>
                    <Icon className={styles.btn__icon} />
                </React.Suspense>
            )}
            <span className={styles.btn__text}>{label}</span>
        </button>
    );
};
